// map UI object to POST/PUT request object
const getSessionModel = (session, eventEditionId) => ({
  id: session.id,
  title: session.title,
  location: session.location,
  sessionDate: session.sessionDate,
  start: session.startTime,
  end: session.endTime,
  description: session.description,
  eventEditionId: eventEditionId,
  sessionSpeakers: session.sessionSpeakerNamesAsString ?
    session.sessionSpeakerNamesAsString
      .split(',')
      .map(x => ({ name: x.trim() }))
      .filter(x => x.name !== '') : []
});

// map GET response objects to UI objects
const getSessions = sessions => {
  return {
    sessions: sessions.map(session => ({
      id: session.id,
      title: session.title,
      location: session.location,
      sessionDate: session.start.split('T')[0],
      startTime: session.start.split('T')[1].split(':').splice(-3, 2).join(':'),
      endTime: session.end.split('T')[1].split(':').splice(-3, 2).join(':'),
      description: session.description,
      sessionSpeakers: session.speakers || [],
      sessionSpeakerNamesAsString: session.speakers ?
        session.speakers.map(x => x.name).join(', ') : ''
    }))
  };
};

export default {
  getSessionModel,
  getSessions
};
